import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionOverviewReport } from './Pages';

export const LeafCollectionOverviewReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LeafCollectionOverviewReport} />
    </Fragment>
)